import {useMemo} from 'react'
import {useGate} from 'statsig-react'

import {dayjs} from '@product-web/dates/dayjs'
import {useVendorCard} from '@product-web-features/vendor-cards/lib/use-vendor-card'

import {bffHooks} from '../bff-hooks'

const oneYearBefore = dayjs().subtract(1, 'year').format('YYYY-MM-DD')
const today = dayjs().startOf('day').format('YYYY-MM-DD')

export const useSpendActivationTemplates = () => {
    const {value: featureGateEnabled} = useGate('spend_activation_templates')

    const {canUseVendorCards} = useVendorCard()

    const canCheckForVendorCardsAndRecurringSpend = featureGateEnabled && canUseVendorCards

    const {data: {hasVendorCards = false, hasRecurringSpend = false} = {}} =
        bffHooks.vendorCards.spendActivationTemplates.getVendorCardsAndRecurringSpend.useQuery(
            {from: [oneYearBefore], to: [today]},
            {enabled: canCheckForVendorCardsAndRecurringSpend},
        )

    return useMemo(
        () => ({
            isEnabled: featureGateEnabled && canUseVendorCards,
            hasVendorCards,
            hasRecurringSpend,
        }),
        [featureGateEnabled, canUseVendorCards, hasVendorCards, hasRecurringSpend],
    )
}
